import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/seasons-banner-mobile.png")